import React from "react";
import Layout from "components/yenimahalle/Layout.js";

import BasicHeader from "components/yenimahalle/BasicHeader.js";
import AlbumImages from "components/yenimahalle/AlbumImages.jsx";

import baskan_1 from "images/yenimahalle/baskan_1.jpg";
import baskan_2 from "images/yenimahalle/baskan_2.jpg";
import baskan_3 from "images/yenimahalle/baskan_3.jpg";
import baskan_4 from "images/yenimahalle/baskan_4.jpg";
import baskan_5 from "images/yenimahalle/baskan_5.jpg";
import baskan_6 from "images/yenimahalle/baskan_6.jpg";
import baskan_7 from "images/yenimahalle/baskan_7.jpg";
import baskan_8 from "images/yenimahalle/baskan_8.jpg";
import baskan_9 from "images/yenimahalle/baskan_9.jpg";
import baskan_10 from "images/yenimahalle/baskan_10.jpg";
import baskan_11 from "images/yenimahalle/baskan_11.jpg";
import baskan_12 from "images/yenimahalle/baskan_12.jpg";
import baskan_13 from "images/yenimahalle/baskan_13.jpg";
import baskan_14 from "images/yenimahalle/baskan_14.jpg";
import baskan_15 from "images/yenimahalle/baskan_15.jpg";
import baskan_16 from "images/yenimahalle/baskan_16.jpg";
import baskan_17 from "images/yenimahalle/baskan_17.jpg";
import baskan_18 from "images/yenimahalle/baskan_18.jpg";
import baskan_19 from "images/yenimahalle/baskan_19.jpg";

export default function YenimahalleAlbum() {
  const albumImages = [
    baskan_1,
    baskan_2,
    baskan_3,
    baskan_4,
    baskan_5,
    baskan_6,
    baskan_7,
    baskan_8,
    baskan_9,
    baskan_10,
    baskan_11,
    baskan_12,
    baskan_13,
    baskan_14,
    baskan_15,
    baskan_16,
    baskan_17,
    baskan_18,
    baskan_19
  ];
  return (
    <Layout>

      <BasicHeader
        headingLine1="Başkanımızla"
        headingLine2="fotoğraflar"
      />

      <AlbumImages
        images={albumImages}
      />

    </Layout>
  );
}
